import styled from 'styled-components';

export const RydeAssuredWrapper = styled.div`
    padding: 2rem 0 2rem 0.8rem;
    border-radius: 0.4rem;
    background-color: #ffeeef;
    display: flex;
    flex-direction: column;
    margin: ${p => p.margin && p.margin};
    position: relative;
    .slick-slide {
        display: flex !important;
        margin-right: 0.8rem;
        width: 21.3rem !important;
    }
    .slick-track {
        // width: 132.6rem !important;
    }
    .slick-arrow {
        display: none !important;
    }
`;
export const RydeAssuredHeader = styled.div`
    display: flex;
    align-items: center;
    width: 100%;
    margin-bottom: 1.5rem;
    h4{
        font-family: 'Rubik';
        font-size: 1.8rem;
        font-weight: 600;
        line-height: 2.4rem;
        color: ${p => p.theme ? p.theme.colors.black.base : '#141823'};
    }
    p{
        font-size: 1.4rem;
        line-height: 1.8rem;
        color: #141823;
    }
`;
export const RydeAssuredTag = styled.div`
    width: 19.4rem;
    height: 4.8rem;
    flex-shrink: 0;
    padding-left: 0.3rem;
    margin-right: 1.2rem;
    display: flex;
    align-items: center;
    justify-content: center;
`;
export const RydeAssuredList = styled.div`
    display: flex !important;
    width: 21.3rem !important;
    height: 8.2rem;
    overflow: hidden;
    border-radius: 0.8rem;
    background-color: #fff;
    padding: 1.5rem 0.8rem 1.3rem 0.8rem;
    align-items: flex-start;
    margin-right: 10px;
    .itemTop {
        display: flex;
        flex-direction: column;
        margin-left: 0.8rem;
    }
    .title {
        font-weight: 600;
        font-size: 1.4rem;
        margin-bottom: 0.4rem;
        color: #141823;
    }
    .subTitle {
        color: #4f525a;
        font-size: 1.2rem
    }
`;

export const PrevNextBtnContainer = styled.p`
    display: flex;
    position: absolute;
    right: 0.9rem;
    top: 3.2rem;
`

export const PrevBtnSpan = styled.span`
    display: flex;
    pointer-events: ${p => p.hidden ? 'none' : 'auto'};
    margin-right: 0.8rem
`

export const NextBtnSpan = styled.span`
    display: flex;
    pointer-events: ${p => p.hidden ? 'none' : 'auto'};
`
export const RudeAssuredPromises = styled.div`
    display: flex;
    justify-content: space-enenly;
`